import { render, staticRenderFns } from "./HistoricBreakdownsLift.vue?vue&type=template&id=f9dbfcc2"
import script from "./HistoricBreakdownsLift.vue?vue&type=script&lang=js"
export * from "./HistoricBreakdownsLift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports